export default __webpack_public_path__ + "static/media/up-green-v2.3fb0e95c.svg";